<script>
import Switches from "vue-switches"
import AgreementPriceListTable from "./components/AgreementPriceListTable.vue"
import AgreementNfseFields from "./components/AgreementNfseFields.vue"
import { validateAgreement, normalizeAgreementPayload } from "@/helpers/validators/agreement"

export default {
  components:{
    Switches,
    AgreementPriceListTable,
    AgreementNfseFields,
  },
  props: {
    currentUser: { type: Object },
    currentEmpresa: { type: Object },
    currentConvenio: { type: Object },
    listSpecialties: { type: Array },
    listCodeTax: { type: Array, default: () => [] },
  },
  data() {
    return {
      loader: {
        get: false
      },
      convenio:{},
      convenio_itens: [],
      errors: {},
    }
  },
  created(){
    this.convenio = { ...this.currentConvenio }
    this.convenio_itens = this.convenio.price_lists.map(item => {
      return {
        specialty: this.listSpecialties.find(specialty => specialty.id === item.specialty_id),
        service_value: this.formatterFloatBR(item.service_value),
        transfer_amount: this.formatterFloatBR(item.transfer_amount)
      }
    })
  },
  mounted() {
    this.$emit('newTitle', 'Alterar Convenio')
  },
  computed: {
    countItens() {
      return this.convenio_itens.length
    },
    permission() {
      return this.currentUser.roles.some(role => role.name === 'super' || role.name === 'admin')
    },
  },
  methods: {
    setPut() {
      this.errors = validateAgreement({
        convenio: this.convenio,
        priceList: this.convenio_itens,
        requirePriceList: false,
      })

      if (Object.keys(this.errors).length > 0) {
        this.$bvToast.toast(Object.values(this.errors).join(', '), {
          title: 'Atenção',
          variant: 'warning',
          solid: true,
        })
        return
      }

      const payload = normalizeAgreementPayload(this.convenio)
      payload.price_list = this.convenio_itens.map(item => {
        return {
          agreement_id: this.convenio.id,
          specialty_id: item.specialty.id,
          service_value: this.new_convert_srting_float(item.service_value),
          transfer_amount: this.new_convert_srting_float(item.transfer_amount)
        }
      })

      this.$emit('doPut', payload)
    },
  },
}
</script>

<template>
<div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-md-9">
          <label for="">{{ "*Nome" }}</label>
          <input v-model="convenio.name" type="text" class="form-control text-left" />
        </div>
        <div class="col-md-3">
          <h5 class="mt-4 font-size-14 mb-4">É Particular?</h5>
          <switches v-model="convenio.is_private" color="success" class="ml-1"></switches>
        </div>
      </div>

      <AgreementNfseFields
        :convenio="convenio"
        :listCodeTax="listCodeTax"
        :errors="errors"
      />
    </div>
    <div class="card-body">
      <div role="tablist">
        <b-card no-body class="mb-1 shadow-none">
          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a
                v-b-toggle.accordion-1
                class="text-dark"
                href="javascript: void(0);"
              >Tabela de Preços</a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-1" accordion="price-list" role="tabpanel">
            <b-card-body>
              <b-card-text>
                <div class="row">
                  <div class="col-md-12">
                    <AgreementPriceListTable
                      v-model="convenio_itens"
                      :listSpecialties="listSpecialties"
                      :permission="permission"
                    />
                  </div>
                </div>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>
    <div class="card-body">
      <div class="col-md-12 mt-10">
        <button class="btn btn-success" @click.prevent="setPut()">
          Gravar
        </button>
      </div>
    </div>
  </div>
</template>
